import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable()
export class HelpOptiosModalService {

  private _openHelpModal$ = new Subject<boolean>();

  public setOpenHelpModal(v: boolean): void {
    this._openHelpModal$.next(v);
  }

  public get openHelpModal$(): Observable<boolean> {
    return this._openHelpModal$.asObservable();
  }
  
}
